import type { SubtitlePosition } from "@ai-teach/types";

/**
 * Vertical placement for the caption overlay, shared by the player and the subtitle editor
 * so what an author sees while editing timings matches what the player shows.
 *
 * Both `offset` (the authored nudge) and `edgeInsetPercent` (the base clearance from the
 * anchored edge) are percentages of the player's height, not pixels — the web preview's box
 * and a phone's screen are wildly different absolute sizes, so a flat px/dp value would land
 * at a different relative height on each; a percentage lands at the same relative spot on both.
 * See CAPTION_EDGE_INSET_PERCENT in @ai-teach/types, the shared source for edgeInsetPercent.
 */
export function getSubtitleOverlayStyle(
  position: SubtitlePosition,
  offset: number,
  edgeInsetPercent: number
): React.CSSProperties {
  if (position === "top") return { top: `${edgeInsetPercent + offset}%` };
  if (position === "center")
    return { top: `calc(50% + (${offset} * 1%))`, transform: "translateY(-50%)" };
  return { bottom: `${edgeInsetPercent - offset}%` };
}
